import { render, staticRenderFns } from "./teachingtask.vue?vue&type=template&id=a1030cfe&scoped=true"
import script from "./teachingtask.vue?vue&type=script&lang=js"
export * from "./teachingtask.vue?vue&type=script&lang=js"
import style0 from "./teachingtask.vue?vue&type=style&index=0&id=a1030cfe&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1030cfe",
  null
  
)

export default component.exports